import { forwardRef, useEffect } from 'react';
import styled, { css } from 'styled-components';

const TextArea = styled.textarea`
  font-family: CeraPro;
  padding: 16px;
  font-size: ${(props) => (props.size ? props.size : '16px')};
  border: ${(props) => (props.border ? props.border : '1px solid #ddd')};
  background-color: ${(props) => (props.bg ? props.bg : 'transparent')};
  color: ${(props) => (props.col ? props.col : 'inherit')};
  height: ${(props) => props.ht || 'auto'};
  ${(props) =>
    props.ht &&
    `
    min-height: ${props.ht};
    max-height: ${props.ht};
    height: ${props.ht};
  `};

  ${(props) => `
    min-width: calc(${props.wid || '100%'} - 32px);
    max-width: calc(${props.wid || '100%'} - 32px);
    width: calc(${props.wid || '100%'} - 32px);
  `};

  ${(props) =>
    props.hasFlex &&
    css`
      display: flex;
      flex: 1;
    `};

  ${(props) =>
    props.hasRadius &&
    css`
      border-radius: ${props.hasRadius};
    `};
  ${(props) =>
    props.pad &&
    css`
      padding: ${props.pad};
    `};

  ${(props) =>
    props.dark &&
    !props.noShadow &&
    css`
      box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.11);
    `};
`;

const StyledTextArea = forwardRef((props, ref) => {
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    const valueLength = ref.current.value.length;
    ref.current.setSelectionRange(valueLength, valueLength);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  function handleKeyDown(e) {
    const { submit, cancel } = props;

    // allow line break on shift + enter key
    if (e.keyCode === 13 && e.shiftKey) return;

    // enter key
    if (e.keyCode === 13 && submit) submit();
    // esc key
    if (e.keyCode === 27 && cancel) cancel();
  }

  return <TextArea ref={ref} {...props} />;
});

export default StyledTextArea;

// class StyledTextArea extends React.Component {
//   componentDidMount() {
//     document.addEventListener('keydown', this.handleKeyDown)
//
//     // focus on last character
//     const valueLength = this.input.value.length
//     this.input.setSelectionRange(valueLength, valueLength)
//   }
//
//   componentWillUnmount() {
//     document.removeEventListener('keydown', this.handleKeyDown)
//   }
//
//   handleKeyDown = (e) => {
//     const { submit, cancel } = this.props
//     // allow line break on shift + enter key
//     if(e.keyCode === 13 && e.shiftKey) return
//
//     // enter key
//     if(e.keyCode === 13 && submit) submit()
//     // esc key
//     if(e.keyCode === 27 && cancel) cancel()
//   }
//   render () {
//     return
//   }
// }
